import displayTextRangeResolver from './displayTextRangeResolver'

export default displayTextRangeResolver
